import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("video", { autoplay: "" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_sidebar_button = _resolveComponent("app-sidebar-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_sidebar_button, {
      caption: "Техническая поддержка",
      icon: "question",
      type: "button",
      "data-qa": "AppSidebarButtonSupportTechnical",
      "text-data-qa": "AppSidebarButtonSupportTechnicalText",
      "is-wide": $props.isWide,
      "is-disabled": $data.isLoading,
      onClick: $options.relocate
    }, null, 8, ["is-wide", "is-disabled", "onClick"]),
    (_ctx.$can('showBannerAdminPanel', 'AppSidebarRequests'))
      ? (_openBlock(), _createBlock(_component_app_sidebar_button, {
          key: 0,
          "is-wide": $props.isWide,
          "included-routes": [
        'crm',
      ],
          to: { name: 'banner-admin-panel' },
          caption: "Настройка баннера",
          icon: "copy"
        }, null, 8, ["is-wide"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "screenBlock",
      class: _normalizeClass(_ctx.$style.screenBlock)
    }, _hoisted_2, 2)
  ]))
}